import api from './api'
import reducer from './reducers'

/**
 * This interface is for a Config plugin.
 * @type {string}
 */
const name = 'config'

export default {
  reducer,
  name,
  api
}
